export default __webpack_public_path__ + "static/media/feedback.c8fc6b37.svg";